<template>
    <div>
      <b-card class="bg-light-secondary text-center">
        <load-page v-show="!ready"></load-page>
        <b-card-body v-show="ready" >
          <b-card-title class="text-center">장치 현황</b-card-title>
          <b-table 
            v-if="sprayerList.length > 0"
            small 
            fixed 
            :items="sprayerList" 
            :fields="sprayerFields">
          </b-table>
          <b-table 
            v-if="curtainList.length > 0"
            small 
            fixed 
            :items="curtainList" 
            :fields="curtainFields">
          </b-table>
          <b-table 
            v-if="fanList.length > 0"
            small 
            fixed 
            :items="fanList" 
            :fields="fanFields">
          </b-table>
          <b-table 
            v-if="lightList.length > 0"
            small 
            fixed 
            :items="lightList" 
            :fields="lightFields">
          </b-table>
          <b-table 
            v-if="plcInverterList.length > 0"
            small 
            fixed 
            :items="plcInverterList" 
            :fields="plcInverterFields">
          </b-table>
          <div
            v-if="plcCurtainList.length > 0"
          >
            <b-table 
              small 
              fixed 
              :items="plcCurtainTitle" 
              :fields="plcCurtainTitleFields">
            </b-table>
            <b-table 
              small 
              fixed 
              :items="plcCurtainList" 
              :fields="plcCurtainFields">
            </b-table>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </template>
  
  <script>
  import {
    BCardBody,
    BCardTitle,
    BTable,
    BRow,
    BCard,
    BCol,
    BSpinner
  } from 'bootstrap-vue'
  
  import { getUserData } from '@/auth/utils'
  import LoadPage from '@/views/pages/utils/LoadPage.vue';
  import store from '@/store'
  
  export default {
    components: {
      LoadPage,
      BCardBody,
      BCardTitle,
      BTable,
      BCard,
      BSpinner,
      BRow,
      BCol,
    },
    props: {
      ready: {
        type: Boolean,
        default: false       
      }
    },
    data() {
      return {
        sprayerList: [],
        curtainList: [],
        fanList: [],
        lightList: [],
        plcInverterList: [],
        sprayerFields: [],
        curtainFields: [],
        plcInverterFields: [],
        plcCurtainList:[],
        plcCurtainTitle: [],
        plcCurtainTitleFields: [
            {
              key: "name",
              label: "장치"
            },
            {
              key: "mode",
              label: "모드"
            },
            {
              key: "temperature",
              label: "온도"
            },
            {
              key: "humidity",
              label: "습도"
            },
            {
              key: "rain",
              label: "강우"
            },
        ]
      }
    },
    created() {
      this.openData = 'Hello World'
    },
    mounted() {
      
    },
    methods: {
      async init(farmId) {
        this.fanList = []
        this.lightList = []
        this.sprayerList = []
        this.curtainList = []
        this.plcInverterList = []
        this.plcCurtainList = []
        this.plcCurtainTitle = []
        this.sprayerFields = this.setFields('안개분무')
        this.curtainFields = this.setFields('커튼')
        this.lightFields = this.setFields('조명')
        this.fanFields = this.setFields('선풍기')
        this.plcInverterFields = this.setInverterFields()
        this.plcCurtainFields = this.setCurtainFields()
        const Val = await store.dispatch('button/fetchButtons', { userId: getUserData().id, farmId })
        for(let button of Val.data) {
          if( button.type === 'curtain' || button.type === 'sprayer' || button.type === 'light' || button.type === 'fan') {
            this[`${button.type}List`].push({
              name: button.name,
              command: this.getUserCommand(button.command),
              isAuto: button.isAuto? '○': 'x'
            })
          }
          if( button.type === 'plc_curtain' ) {
            let crtResult
            let curtainData
            try {
              crtResult = await store.dispatch('button/getStateByCommand', { id: button._id, command: 'main'})
              curtainData = crtResult.data.data
              for (let ch of curtainData.btnInfo) {
                if(ch.name == 0) {
                  if(this.getUserCommand(ch.state) !== '-') break 
                  else {
                    this.plcCurtainTitle.push({
                      name: button.name,
                      mode: (curtainData.mode === 'Remote')? '원격': '수동',
                      state: this.getUserCommand(ch.state),
                      temperature: `${curtainData.sensorInfo['temperature']} ℃`,
                      humidity: `${curtainData.sensorInfo['humidity']}％`,
                      rain: curtainData.sensorInfo['rain'] === 'Ready'? '대기': '감지'
                    })
                    continue
                  }
                } 
                else {
                  if(!ch.able) continue
                  this.plcCurtainList.push({
                    name: `${button.name} CH${ch.name}`,
                    mode: ch.mode === 'Auto' ? '자동': '수동',
                    state: this.getUserCommand(ch.state),
                  })
                }
              }
            } catch (error) {
              this.plcCurtainTitle.push({
                name: button.name,
                mode: `-`,
                state: `-`,
                temperature: `-`,
                humidity: `-`,
                rain: `-`
              })
            }
          }
          if( button.type === 'plc_inverter_iv') {
            const cmdResult = await store.dispatch('button/getStateByCommand', { id: button._id, command: 'init'})
            const mode = cmdResult.data.data.remote === 'Remote'? '원격' : '로컬'
            const inv2 = cmdResult.data.data.inv2
            const inv1Result = await store.dispatch('button/getStateByCommand', { id: button._id, command: '1status'})
            let power = inv1Result.data.data.frqPercentage
            let temp = inv1Result.data.data.temperature
            let volt = inv1Result.data.data.volt
            let current = inv1Result.data.data.current
            this.plcInverterList.push({
              name: `${button.name} [inv1]`,
              mode,
              temp: `${temp} ℃`,
              power: `${power} ％`,
              watt:  `${parseInt(volt * current)} W`,
              test: `${parseInt(volt * current / Math.pow(10, 2)) * 2 } △`
            })
            if(inv2) {
              const inv2Result = await store.dispatch('button/getStateByCommand', { id: button._id, command: '2status'})
              power = inv2Result.data.data.frqPercentage
              temp = inv2Result.data.data.temperature
              volt = inv2Result.data.data.volt
              current = inv2Result.data.data.current
              this.plcInverterList.push({
                name: `${button.name} [inv2]`,
                mode,
                temp: `${temp} ℃`,
                power: `${power} ％`,
                watt: `${parseInt(volt * current)} W`,
                test: `${parseInt(volt * current / Math.pow(10, 2)) * 2} △`
              })
            }
          }
        }
        return {
          curtain: this.curtainList,
          sprayer: this.sprayerList,
          inverter: this.plcInverterList
        }
      },
      setCurtainFields() {
        return [
          { 
            key: 'name',
            label: `이름` 
          },
          {
            key: 'mode',
            label: `모드` ,
          },
          {
            key: 'state',
            label: `동작` ,
          },
        ]
      },
      setInverterFields() {
        return [
          { 
            key: 'name',
            label: `인버터` 
          },
          {
            key: 'mode',
            label: `모드` ,
          },
          {
            key: 'temp',
            label: `온도` ,
          },
          {
            key: 'power',
            label: `출력` 
          },
          {
            key: 'watt',
            label: `소비전력` 
          },
          {
            key: 'test',
            label: `전일대비` 
          },
        ]
      },
      setFields (type) {
        return [
          { 
            key: 'name',
            label: `${type} 목록` 
          }, 
          {
            key: 'command', 
            label: '동작' 
          },
          {
            key: 'isAuto',
            label: '자동화'
          }
        ]
      },
      getUserCommand (cmd) {
        switch (cmd) {
          case 'Open':
          case 'open': return '열림'
          case 'Close':
          case 'close': return '닫힘'
          case 'Stop':
          case 'stop': return '정지'
          case 'work': return '동작'
          default: return '-'
        }
      }
    },
  }
  </script>
  
  <style>
  
  
  </style>
  